export default __webpack_public_path__ + "img/location.d4f3c832.svg";